import { render } from "./InvoiceCreateFooterActions.vue?vue&type=template&id=6126c1de"
import script from "./InvoiceCreateFooterActions.vue?vue&type=script&lang=js"
export * from "./InvoiceCreateFooterActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__